export default __webpack_public_path__ + "static/media/azad.95e691a3.webp";